import React from "react";
import { Skeleton, CardContent, Card, Paper, useTheme } from "@mui/material";

const SkeletonCard = () => {
  const theme = useTheme();
  return (
    <Paper elevation={5}>
      <Card
        style={{
          zIndex: 900,
          width: "375px",
          minHeight: "320px",
          maxHeight: "350px",
          background: "linear-gradient(to left, #ff8300, #ff4700)",
          color: theme.palette.success.text,
        }}
      >
        {/* CardHeader skeleton */}
        <Skeleton variant="rect" height={45} animation="wave" />

        {/* CardContent skeleton */}
        <CardContent
          style={{
            color: "whitesmoke",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Skeleton
            variant="circle"
            width={80}
            height={80}
            animation="wave"
            sx={{ marginTop: "40px" }}
          />
          <Skeleton
            variant="text"
            width="95%"
            height={30}
            animation="wave"
            sx={{ marginTop: "10px" }}
          />
          <Skeleton
            variant="text"
            height={25}
            width="90%"
            animation="wave"
            sx={{ marginTop: "5px" }}
          />
          <Skeleton
            variant="rect"
            height={20}
            width="100%"
            animation="wave"
            sx={{ marginTop: "30px" }}
          />
        </CardContent>

        {/* CardHeader skeleton */}
        <Skeleton variant="rect" height={20} animation="wave" />
      </Card>
    </Paper>
  );
};

export default SkeletonCard;
